import React from 'react'

import { Route, Switch } from 'react-router-dom'
import CaseMobly from '../pages/CaseMobly'

import LandingPage from '../pages/LandingPage'

function Routes() {
  return (
    <Switch>
      <Route path="/" exact component={LandingPage} />
      <Route path="/mobly" component={CaseMobly} />
      <Route path="*" component={LandingPage} />
    </Switch>
  )
}

export default Routes
